import React from 'react';

export default class NoRouteMatch extends React.Component {
  render(){
    return (<div>404 - This page does not exist</div>)
  }
}
